var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6C9.65685 6 11 4.65685 11 3C11 1.34315 9.65685 0 8 0C6.34315 0 5 1.34315 5 3C5 4.65685 6.34315 6 8 6Z",
    fill: "#2E81FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12338 8.11043C4.05756 7.51807 4.52125 7 5.11726 7H10.8827C11.4787 7 11.9424 7.51807 11.8766 8.11043L11.0988 15.1104C11.0426 15.6169 10.6145 16 10.105 16H5.89504C5.38549 16 4.95743 15.6169 4.90116 15.1104L4.12338 8.11043Z",
    fill: "#2E81FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.16307 9.14142C0.0770085 8.53899 0.544471 8 1.15302 8H3.00001V8.3379C3.00001 8.77855 3.03642 9.21844 3.10886 9.65309L4.00001 15H1.86731C1.36966 15 0.947735 14.6341 0.877356 14.1414L0.16307 9.14142Z",
    fill: "#2E81FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15L12.8912 9.65309C12.9636 9.21844 13 8.77855 13 8.3379V8H14.847C15.4555 8 15.923 8.53899 15.8369 9.14142L15.1227 14.1414C15.0523 14.6341 14.6304 15 14.1327 15H12Z",
    fill: "#2E81FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5C4 6.10457 3.10457 7 2 7C0.895431 7 0 6.10457 0 5C0 3.89543 0.895431 3 2 3C3.10457 3 4 3.89543 4 5Z",
    fill: "#2E81FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7C15.1046 7 16 6.10457 16 5C16 3.89543 15.1046 3 14 3C12.8954 3 12 3.89543 12 5C12 6.10457 12.8954 7 14 7Z",
    fill: "#2E81FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFamily);
export default __webpack_public_path__ + "static/media/icon-family.89f1fb59061715b74c3de99a6a7a87fb.svg";
export { ForwardRef as ReactComponent };